import React from 'react'
import {Link as ReactRouterLink} from 'react-router-dom'
import {Box, Divider, Flex, Heading, Text} from '../../utils/chakraMonomorphic'
import {RouterLink as Link} from '../../utils/chakraRouterLink'

interface Props {
  heading: string
  intro: string
  src: string
  iframeTitle: string
}

/**
 * Shared layout for the public legal pages (Privacy Policy, Terms of Service).
 * The two pages differ only in their heading, intro copy, and embedded source,
 * so they pass those in and reuse this chrome.
 */
export const LegalPageView: React.FC<React.PropsWithChildren<Props>> = ({
  heading,
  intro,
  src,
  iframeTitle,
}) => {
  return (
    <Flex
      flexDirection='column'
      minHeight='100vh'
      p={6}
      maxWidth='1200px'
      mx='auto'>
      <Box mb={4}>
        <Link
          as={ReactRouterLink}
          to='/'
          fontSize='sm'
          color='gray.500'
          _hover={{color: 'gray.700'}}>
          ← Campanion Admin
        </Link>
        <Heading size='lg' mt={3} mb={2}>
          {heading}
        </Heading>
        <Text color='gray.600'>{intro}</Text>
      </Box>

      <Divider mb={4} />

      <Box flexGrow={1}>
        <iframe
          src={src}
          title={iframeTitle}
          width='100%'
          style={{border: 'none', minHeight: '80vh', display: 'block'}}
        />
      </Box>
    </Flex>
  )
}
